/**
 * 登出弹出层
 */

import React, { Component } from 'react';
import ReactDOM, { render} from 'react-dom';
import lang from '../../lang/index';
import Modal from 'boron/ScaleModal';


const noop = function(){};

const style = {
    modalStyle: {
        position: 'absolute',
         width: '320px'
    },
    contentStyle: {
        width: '320px',
        borderRadius: '6px',
        backgroundColor: '#fff',
        outline: 0
    },
    backdropStyle: {
        position: 'absolute',
        backgroundColor: "rgba(0,0,0, 0.5)"
    }
}

class OverlayPop  extends Component {
    static defaultProps = {
        onHide: noop,
        onConfirm: noop,
        onCancel: noop,
        title: '',
        content: '',
        type: 'confirm',
        closeOnClick: true
    }
    constructor(props){
        super(props);

        this.status = 'cancel';

        this.state = {
            placeholder: lang.template('我是<%=name%>', { name: props.myusername}),
            applycontent: ''
        }
    }

    onConfirm() {
        this.hideModal();
        this.status = 'confirm';
    }

    onCancel() {
        this.hideModal();
        this.status = 'cancel';
    }

    onHide() {
        if (this.status == 'confirm') {
            this.props.onConfirm(this.state.applycontent || this.state.placeholder);
        } else {
            this.props.onCancel();
        }

        this.props.onHide();
    }

    onShow(){
        if (this.refs.applycontent) {
            this.refs.applycontent.focus();
        }
    }

    showModal(){
        this.refs.modal.show();
    }

    hideModal(){
        this.refs.modal.hide();   
    }

    onChange=(e)=>{
        this.setState({
            applycontent: $(e.currentTarget).val()
        });
    }

    render() {
        let modalStyle = style.modalStyle;
        let backdropStyle = style.backdropStyle;
        let contentStyle = style.contentStyle;
        
        if (this.props.modalStyle) {
            for (let style in this.props.modalStyle) {
                modalStyle[style] = this.props.modalStyle[style];
            }
        }

        if (this.props.backdropStyle) {
            for (let style in this.props.backdropStyle) {
                backdropStyle[style] = this.props.backdropStyle[style];
            }
        }

        if (this.props.contentStyle) {
            for (let style in this.props.contentStyle) {
                contentStyle[style] = this.props.contentStyle[style];
            }
        }

        return (
            <Modal 
                ref="modal" 
                closeOnClick={this.props.closeOnClick}
                modalStyle={modalStyle}  
                backdropStyle={backdropStyle} 
                contentStyle={contentStyle}
                onShow={this.onShow.bind(this)}
                onHide={this.onHide.bind(this)}
            >
                <div className="overlay-pop">
                    <div className="overlay-pop-bd">
                        <div className="apply-confirm-hd" dangerouslySetInnerHTML={{__html: lang.template('您正在向<%=name%>发送好友申请', { name: this.props.friendusername}, 1)}}></div>
                        <div className="apply-confirm-bd">
                            <div className="input-wrap">
                                <input 
                                    type="text" 
                                    ref="applycontent" 
                                    maxLength="20" 
                                    value={this.state.applycontent}
                                    placeholder={this.state.placeholder}
                                    onChange={this.onChange}
                                />
                            </div>
                            <div className="input-tip">{lang.template('请输入20个字以内')}</div>
                        </div>
                    </div>
                    <div className="overlay-pop-ft">
                        <button className="btn cancel" onClick={()=>this.onCancel()}>{lang.template('取消')}</button>
                        <button className="btn confirm" onClick={()=>this.onConfirm()}>{lang.template('确认')}</button>
                    </div>
                </div>
            </Modal>
        );
    }
}

export default OverlayPop;


// WEBPACK FOOTER //
// ./js/im/views/apply-confirm.js